import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { FeatureFlagsService } from '@digital-platform/shared/services';

@Directive({
  selector: '[digitalPlatformFeatureFlag]',
})
export class FeatureFlagDirective {
  private hasView = false;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly featureFlags: FeatureFlagsService
  ) {}

  @Input() set digitalPlatformFeatureFlag(flags: string | string[]) {
    const hasFlags = this.featureFlags.hasFlags(flags);
    if (hasFlags && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasFlags && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
